const ComputedField = ({entity, fld}) => {

    return (
        <span>{fld.valueGetter(entity)}</span>
    )
}

export default ComputedField